import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	background-color: #f3f3f3;
	padding: 12em 0 0;

	.header {
		.top {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			padding-bottom: 2em;

			.headline {
				font-size: 2em;
				font-weight: 700;
				line-height: normal;
			}
		}

		.description {
			font-size: 1.2em;
			padding-bottom: 2em;
		}
	}

	.additional-checkbox-wrapper {
		background-color: #10f5b0;
		width: 100%;
		padding: 1.3em;
		display: flex;
		justify-content: space-between;

		border-radius: 0 0 0.3em 0.3em;

		.additional-checkbox-wrapper-save-info {
			display: flex;
			align-items: center;
			gap: 1em;
			margin-right: 2em;

			.icon {
				width: 1.4em;
			}
			.info {
				font-weight: 600;
			}
		}

		.layout-forms-checkbox {
			max-width: 80%;

			.layout-forms-input-wrapper {
				margin-bottom: 0;
				.internal-wrapper {
					.input-body {
						.checkbox-wrapper {
							.label {
								font-size: 1em;
							}
						}
					}
				}
			}
		}
	}

	.jobs-search-suggested-tags {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 3em 3em 0 3em;
		max-width: 100%;

		.suggested-title {
			margin: 0 1em 0 0;
			min-width: max-content;
			font-size: 1.6em;
		}

		.suggested-tags {
			display: flex;
			flex-flow: row wrap;
			gap: 1em;

			.suggested-tag {
				min-width: max-content;
				text-decoration: underline;
				padding: 1em;
				border: 0.07em solid ${vars.colorBlack};
				border-radius: 20em;

				&.level-high {
					order: 0;
				}
				&.level-mid {
					order: 1;
				}
				&.level-low {
					order: 2;
				}
			}
		}
	}

	.jobs-search-empty-result {
		margin: 2em 0 0 0;

		.empty-title {
			text-align: center;
			font-weight: 500;
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		padding: 6em 0 0;

		.layout-container {
			width: 100%;
		}

		.header {
			display: none;
		}

		.additional-checkbox-wrapper {
			font-size: 140%;
			padding: 2em;
			border-radius: 0;

			.additional-checkbox-wrapper-save-info {
				display: none;
			}
		}

		.jobs-search-suggested-tags {
			flex-flow: column wrap;
			padding: 2em;
			gap: 1em;

			.suggested-title {
				padding: 0;
			}
		}
	}

	@media all and (max-width: ${vars.mobileM}) {
		.public-layout-forms-search-form {
			.public-layout-forms-search-form-blocks-main {
				.title-row {
					padding-top: 3em;

					.form-title {
						font-size: 1em;
					}
				}

				.layout-forms-form {
					padding: 0.2em;

					form {
						font-size: 60%;
						padding-bottom: 2em;
					}
				}

				.children {
					.filter-options {
						.options {
							flex-direction: column;
							font-size: 90%;
							text-align: left;

							.option-container {
								width: 100%;
								border: none;
								color: #fff;
								padding: 0.05em 1em;
								min-height: 3em;

								&:hover {
									background-color: #000;

									.icon {
										display: block;
									}

									.icon-hover {
										display: none;
									}
								}

								.option {
									color: #fff;

									br {
										display: none;
									}

									.icon {
										display: block;
									}

									.icon-hover {
										display: none;
									}
								}

								&.active {
									background-color: #000;
									color: #fff;
								}
							}
						}
					}
				}
			}

			.public-layout-forms-search-form-blocks-expandable-menu {
				.expandable-menu {
					background-color: #000;
					color: #fff;

					.menu-header {
						.layout-button {
							.button {
								color: #fff;
							}
						}
					}

					.layout-forms-input {
						font-size: 90%;
						margin-bottom: 2em;
					}

					.menu-elements {
						display: flex;
						flex-direction: column;

						.element {
							.layout-forms-checkbox {
								.layout-forms-input-wrapper {
									.internal-wrapper {
										.input-body {
											label {
												.label {
													color: #fff;
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}

		.additional-checkbox-wrapper {
			font-size: 120%;
			padding: 2em 1em;
		}

		.jobs-search-suggested-tags {
			padding: 3em 0 3em 0;

			.suggested-tags {
				display: flex;
				flex-flow: row wrap;
				gap: 1em;
				justify-content: center;
			}
		}

		.jobs-search-empty-result {
			margin: 4em 0 0 0;
			padding: 0 0 1em 0;

			.empty-title {
				text-align: left;
				padding: 0 1.7em 0 1.7em;
			}
		}
	}
`;
